import { EUserRoleName, ProjectPermissionEnum } from "../constants";

export const isPermissionNotGranttedUtil = (
  type: ProjectPermissionEnum,
  role: string
) => {
  switch (type) {
    case ProjectPermissionEnum.EditWorkflowTemplate: {
      const roles = [EUserRoleName[EUserRoleName.gc_project_admin]];
      return !roles.some((r) => r === role);
    }
    case ProjectPermissionEnum.EditRiskThreshold: {
      const roles = [EUserRoleName[EUserRoleName.gc_project_admin]];
      return !roles.some((r) => r === role);
    }
    case ProjectPermissionEnum.ViewProjectList: {
      return false; // All have access
    }
    case ProjectPermissionEnum.AddProjectUser: {
      const roles = [
        EUserRoleName[EUserRoleName.gc_project_admin],
        EUserRoleName[EUserRoleName.sc_project_admin],
        EUserRoleName[EUserRoleName.architect],
        EUserRoleName[EUserRoleName.design_engineer]
      ];
      return !roles.some((r) => r === role);
    }
    case ProjectPermissionEnum.EditProjectDetail: {
      const roles = [EUserRoleName[EUserRoleName.gc_project_admin]];
      return !roles.some((r) => r === role);
    }
    case ProjectPermissionEnum.CreateSubmittal: {
      const roles = [EUserRoleName[EUserRoleName.gc_project_admin]];
      return !roles.some((r) => r === role);
    }
    case ProjectPermissionEnum.InlineEditSubmittal: {
      const roles = [EUserRoleName[EUserRoleName.gc_project_admin]];
      return !roles.some((r) => r === role);
    }
    case ProjectPermissionEnum.SubmittalWorkflow: {
      const roles = [
        EUserRoleName[EUserRoleName.sc_project_admin],
        EUserRoleName[EUserRoleName.gc_project_admin],
        EUserRoleName[EUserRoleName.architect],
        EUserRoleName[EUserRoleName.design_engineer],
        EUserRoleName[EUserRoleName.owner],
        EUserRoleName[EUserRoleName.gc_sc_project_admin],
        EUserRoleName[EUserRoleName.gc_sc_architect],
        EUserRoleName[EUserRoleName.gc_sc_design_engineer],
        EUserRoleName[EUserRoleName.gc_sc_owner]
      ];
      return !roles.includes(role);
    }
    case ProjectPermissionEnum.AddTradePartner: {
      const roles = [
        EUserRoleName[EUserRoleName.gc_project_admin],
        EUserRoleName[EUserRoleName.sc_project_admin]
      ];
      return !roles.some((r) => r === role);
    }
    case ProjectPermissionEnum.AddAttachment: {
      const roles = [
        EUserRoleName[EUserRoleName.gc_project_admin],
        EUserRoleName[EUserRoleName.sc_project_admin],
        EUserRoleName[EUserRoleName.architect],
        EUserRoleName[EUserRoleName.design_engineer],
        EUserRoleName[EUserRoleName.owner],
        EUserRoleName[EUserRoleName.gc_sc_project_admin],
        EUserRoleName[EUserRoleName.gc_sc_architect],
        EUserRoleName[EUserRoleName.gc_sc_design_engineer],
        EUserRoleName[EUserRoleName.gc_sc_owner]
      ];
      return !roles.some((r) => r === role);
    }
    case ProjectPermissionEnum.AddEditCalendar: {
      const roles = [EUserRoleName[EUserRoleName.gc_project_admin]];
      return !roles.some((r) => r === role);
    }
    case ProjectPermissionEnum.ViewLinkingPage: {
      const roles = [
        EUserRoleName[EUserRoleName.gc_project_admin],
        EUserRoleName[EUserRoleName.gc_foreman],
        EUserRoleName[EUserRoleName.architect],
        EUserRoleName[EUserRoleName.design_engineer],
        EUserRoleName[EUserRoleName.owner]
      ];
      return !roles.some((r) => r === role);
    }
    case ProjectPermissionEnum.EditLinkingPage: {
      const roles = [EUserRoleName[EUserRoleName.gc_project_admin]];
      return !roles.includes(role);
    }
    case ProjectPermissionEnum.EditDateBlockOffsetSubmittal: {
      const roles = [EUserRoleName[EUserRoleName.gc_project_admin]];
      return !roles.includes(role);
    }
    case ProjectPermissionEnum.EditDateBlockOffsetMaterial: {
      const roles = [
        EUserRoleName[EUserRoleName.gc_project_admin],
        EUserRoleName[EUserRoleName.gc_sc_project_admin]
      ];
      return !roles.includes(role);
    }
    case ProjectPermissionEnum.CreateDistributionGroup: {
      const roles = [EUserRoleName[EUserRoleName.gc_project_admin]];
      return !roles.some((r) => r === role);
    }
    case ProjectPermissionEnum.EditDistributionGroup: {
      const roles = [EUserRoleName[EUserRoleName.gc_project_admin]];
      return !roles.some((r) => r === role);
    }
    case ProjectPermissionEnum.LocationEdit: {
      const roles = [EUserRoleName[EUserRoleName.gc_project_admin]];
      return !roles.some((r) => r === role);
    }
    case ProjectPermissionEnum.CreateMaterial: {
      const roles = [EUserRoleName[EUserRoleName.gc_project_admin]];
      return !roles.includes(role);
    }
    case ProjectPermissionEnum.InlineEditMaterialPrimaryFields: {
      const roles = [EUserRoleName[EUserRoleName.gc_project_admin]];
      return !roles.includes(role);
    }
    case ProjectPermissionEnum.EditMaterialGeneralInfoAndParticipants: {
      const roles = [EUserRoleName[EUserRoleName.gc_project_admin]];
      return !roles.includes(role);
    }
    case ProjectPermissionEnum.EditMaterialCharacteristics: {
      const roles = [
        EUserRoleName[EUserRoleName.gc_project_admin],
        EUserRoleName[EUserRoleName.sc_project_admin],
        EUserRoleName[EUserRoleName.gc_sc_project_admin]
      ];
      return !roles.includes(role);
    }
    case ProjectPermissionEnum.EditMaterialDBOffset: {
      const roles = [
        EUserRoleName[EUserRoleName.gc_project_admin],
        EUserRoleName[EUserRoleName.sc_project_admin],
        EUserRoleName[EUserRoleName.gc_sc_project_admin]
      ];
      return !roles.includes(role);
    }
    case ProjectPermissionEnum.ImportSchedule: {
      const roles = [EUserRoleName[EUserRoleName.gc_project_admin]];
      return !roles.includes(role);
    }
    case ProjectPermissionEnum.MakeActiveSchedule: {
      const roles = [EUserRoleName[EUserRoleName.gc_project_admin]];
      return !roles.includes(role);
    }
    case ProjectPermissionEnum.EditScheduleDetails: {
      const roles = [EUserRoleName[EUserRoleName.gc_project_admin]];
      return !roles.includes(role);
    }
    case ProjectPermissionEnum.changeMaterialActualDate: {
      const roles = [
        EUserRoleName[EUserRoleName.gc_project_admin],
        EUserRoleName[EUserRoleName.sc_project_admin],
        EUserRoleName[EUserRoleName.gc_sc_project_admin]
      ];
      return !roles.includes(role);
    }
    case ProjectPermissionEnum.EditDateblockProjectedDate: {
      const roles = [
        EUserRoleName[EUserRoleName.gc_project_admin],
        EUserRoleName[EUserRoleName.sc_project_admin],
        EUserRoleName[EUserRoleName.gc_sc_project_admin]
      ];
      return !roles.includes(role);
    }
    case ProjectPermissionEnum.changeMaterialPlannedDate: {
      const roles = [EUserRoleName[EUserRoleName.gc_project_admin]];
      return !roles.includes(role);
    }
    case ProjectPermissionEnum.DeleteMaterialAttachment: {
      const roles = [
        EUserRoleName[EUserRoleName.gc_project_admin],
        EUserRoleName[EUserRoleName.sc_project_admin]
      ];
      return !roles.includes(role);
    }
    case ProjectPermissionEnum.ViewProjectReports: {
      const roles = [
        EUserRoleName[EUserRoleName.gc_project_admin],
        EUserRoleName[EUserRoleName.gc_foreman]
      ];
      return !roles.includes(role);
    }
    case ProjectPermissionEnum.UploadSpecSectionFile: {
      const roles = [
        EUserRoleName[EUserRoleName.gc_project_admin],
        EUserRoleName[EUserRoleName.gc_sc_project_admin]
      ];
      return !roles.includes(role);
    }
    case ProjectPermissionEnum.ViewDesignPage: {
      const roles = [
        EUserRoleName[EUserRoleName.gc_project_admin],
        EUserRoleName[EUserRoleName.gc_foreman]
      ];
      return !roles.includes(role);
    }
    case ProjectPermissionEnum.CreateMaterialComment: {
      const roles = [
        EUserRoleName[EUserRoleName.gc_project_admin],
        EUserRoleName[EUserRoleName.gc_foreman],
        EUserRoleName[EUserRoleName.sc_project_admin],
        EUserRoleName[EUserRoleName.sc_foreman],
        EUserRoleName[EUserRoleName.architect],
        EUserRoleName[EUserRoleName.design_engineer],
        EUserRoleName[EUserRoleName.owner],
        EUserRoleName[EUserRoleName.gc_sc_project_admin],
        EUserRoleName[EUserRoleName.gc_sc_foreman],
        EUserRoleName[EUserRoleName.gc_sc_architect],
        EUserRoleName[EUserRoleName.gc_sc_design_engineer],
        EUserRoleName[EUserRoleName.gc_sc_owner]
      ];
      return !roles.includes(role);
    }
    case ProjectPermissionEnum.CreateMaterialCommentIfAssignee: {
      const roles = [
        EUserRoleName[EUserRoleName.gc_sc_project_admin],
        EUserRoleName[EUserRoleName.owner],
        EUserRoleName[EUserRoleName.gc_sc_owner]
      ];
      return !roles.includes(role);
    }
    case ProjectPermissionEnum.ChangeMaterialTemplate: {
      const roles = [EUserRoleName[EUserRoleName.gc_project_admin]];
      return !roles.includes(role);
    }
    case ProjectPermissionEnum.EditMaterialDBTemplate: {
      const roles = [EUserRoleName[EUserRoleName.gc_project_admin]];
      return !roles.includes(role);
    }

    case ProjectPermissionEnum.BidPackageWrite: {
      const roles = [EUserRoleName[EUserRoleName.gc_project_admin]];
      return !roles.includes(role);
    }
    case ProjectPermissionEnum.DesignPackageWrite: {
      const roles = [EUserRoleName[EUserRoleName.gc_project_admin]];
      return !roles.includes(role);
    }
    case ProjectPermissionEnum.RequestLeadTime: {
      const roles = [EUserRoleName[EUserRoleName.gc_project_admin]];
      return !roles.includes(role);
    }
    case ProjectPermissionEnum.addProjectIntegration: {
      const roles = [EUserRoleName[EUserRoleName.gc_project_admin]];
      return !roles.includes(role);
    }
    case ProjectPermissionEnum.changeProjectIntegration: {
      const roles = [EUserRoleName[EUserRoleName.gc_project_admin]];
      return !roles.includes(role);
    }
    case ProjectPermissionEnum.CanSetLBSForMaterial: {
      const roles = [EUserRoleName[EUserRoleName.gc_project_admin]];
      return !roles.includes(role);
    }
    case ProjectPermissionEnum.CanConfigureCustomReports: {
      const roles = [
        EUserRoleName[EUserRoleName.gc_project_admin],
        EUserRoleName[EUserRoleName.gc_sc_project_admin]
      ];
      return !roles.includes(role);
    }
    default:
      return true;
  }
};
